export enum CompetitionStatus {
  ONGOING = 'Ongoing',
  UPCOMING = 'Upcoming',
  ENDED = 'Ended',
}

export enum CompetitionFilterMode {
  ONGOING = 'Ongoing',
  UPCOMING = 'Upcoming',
  ENDED = 'Ended',
  JOINED = 'Joined',
}

export enum CompetitionType {
  VOLUME = 'Volume',
  PNL = 'PnL',
}

export enum SortOption {
  NEW_TO_OLD = 'New to Old',
  OLD_TO_NEW = 'Old to New',
}

export enum CompetitionRuleId {
  DEFAULT = 'DEFAULT',
  TOP_WIN_AND_LOSS_PNL = 'TOP_WIN_AND_LOSS_PNL',
}

export interface Competition {
  id: number;
  title: string;
  description?: string;
  banner?: string; // URL or path
  type: CompetitionType;
  status: CompetitionStatus;
  tradingVolume: number;
  endTime: number; // timestamp in ms
  startTime: number; // timestamp in ms
  rewardAmount?: string;
  rewardTokenAddress?: string;
  rewardDescription?: string;
  ruleLink?: string;
  ruleId?: CompetitionRuleId;
  currentParticipants: number;
  hasJoined: boolean;
}

